'use client';

interface BlogPostSkeletonProps {
  count?: number;
}

export function BlogPostSkeleton({ count = 6 }: BlogPostSkeletonProps) {
  return (
    <div className="grid gap-6 md:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="relative overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          {/* Image Skeleton */}
          <div className="mb-5 overflow-hidden rounded-xl bg-gray-200 dark:bg-gray-800 animate-pulse">
            <div className="h-40 md:h-48 w-full" />
          </div>

          {/* Date Skeleton */}
          <div className="flex items-center gap-2 mb-3">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-4 w-32 rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>

          {/* Title Skeleton */}
          <div className="mb-3 space-y-2">
            <div className="h-6 w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-6 w-3/4 rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>

          {/* Description Skeleton */}
          <div className="mb-4 space-y-2">
            <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-4 w-2/3 rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>

          {/* Read More Button Skeleton */}
          <div className="mt-2">
            <div className="h-5 w-24 rounded bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>

          {/* Shimmer Effect Overlay */}
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 dark:via-white/5 to-transparent" />
        </div>
      ))}
    </div>
  );
}

